import { returnFileFromResponse, throwBlobError } from 'packages/common/utils/file';
import resource from '../resource';

export function generateBankFile(bankFile) {
  return resource.generateBankFile(bankFile)
    .then(returnFileFromResponse)
    .catch(throwBlobError);
}
